const randomElement = (arr = []) => {
  return arr[Math.floor(Math.random() * arr.length)];
};

const kebab = str => {
  return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};

const toggleFullScreen = () => {
  let doc = window.document;
  let docEl = doc.documentElement;

  let requestFullScreen =
    docEl.requestFullscreen ||
    docEl.mozRequestFullScreen ||
    docEl.webkitRequestFullScreen ||
    docEl.msRequestFullscreen;
  let cancelFullScreen =
    doc.exitFullscreen ||
    doc.mozCancelFullScreen ||
    doc.webkitExitFullscreen ||
    doc.msExitFullscreen;

  if (
    !doc.fullscreenElement &&
    !doc.mozFullScreenElement &&
    !doc.webkitFullscreenElement &&
    !doc.msFullscreenElement
  ) {
    requestFullScreen.call(docEl);
  } else {
    cancelFullScreen.call(doc);
  }
};

export default {
  randomElement,
  toggleFullScreen,
  kebab
};

export let pagination = {
  keySearch: '',
  pageIndex: 1,
  pageSize: 10000
};

export const FirebaseConfig = {
  apiKey: 'AIzaSyCjGYSgwQX64wSNmyKzcKWKX4w9piDfPHM',
  authDomain: 'motrak-prod.firebaseapp.com',
  databaseURL: 'https://motrak-prod.firebaseio.com',
  projectId: 'motrak-prod',
  storageBucket: 'motrak-prod.appspot.com',
  messagingSenderId: '937394211057',
  appId: '1:937394211057:web:fac3d2ca9db73178e70150'
};

export const ClientIdOAuth2 = '372863546805-f1ag5u283j6toscosg9t87fcjvgni1qh';
export const AppIdFacebook = '762152724620702';
export const AppIdZalo = '3112856539083874774';


// WEBPACK FOOTER //
// ./src/utils/index.js